export default {
  path: '/talentSendPlayer',
  name: 'TalentSendPlayer',
  redirect: '/talentSendPlayer/list',
  component: () => import('@/components/layout'),
  meta: {requiresAuth: true},
  children: [
    {
      path: 'list',
      component: () => import('@/views/talentSendPlayer/talentSendPlayerList'),
      meta: {requiresAuth: true},
    },
    {
      path: 'addTalentSendPlayer',
      component: () => import('@/views/talentSendPlayer/addPlayerTalentSend'),
      meta: {requiresAuth: true},
    },
    {
      path: 'editTalentSendPlayer',
      component: () => import('@/views/talentSendPlayer/editPlayerTalentSend'),
      meta: {requiresAuth: true},
    },
    {
      path: 'viewTalentSendPlayer',
      component: () => import('@/views/talentSendPlayer/talentSendPlayerDetails'),
      meta: {requiresAuth: true},
    },
  ]
}
